/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import {Component, Input, OnInit} from '@angular/core';
import {Driver} from "../model/Driver";
import {ActivatedRoute} from "@angular/router";
import {DriverService} from "../services/driver.service";

@Component({
    selector: 'app-accident-list',
    templateUrl: './accidentList.component.html',
    styleUrls: ['./accidentList.component.less'],
    standalone: false
})
export class AccidentListComponent implements OnInit {

  isSuperAdmin = (sessionStorage.getItem("isSuperAdmin")=="true");
  isEditable = (sessionStorage.getItem("isSiteAdmin") === "true");
  public urlDriverID = +this.route.snapshot?.paramMap.get('id');

  @Input() driver: Driver;

  constructor(
    private driverService: DriverService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit() {
    if (this.isSuperAdmin)
      this.isEditable=true;

    this.getDriver();

  }

  getDriver() {
    this.driverService.getDriver(this.urlDriverID)
      .subscribe(driver => {
        this.driver = driver;
      });
  }

}
